
// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getAllergenOptions } from '../../constants/DietaryConstants';

// -- views
import LocalizableSelect from './LocalizableSelect';

class AllergenChooser extends Component {

  static defaultProps = {
    clearable: true,

    readOnly: false
  };

  static propTypes = {
    allergens: PropTypes.array.isRequired,

    onChange: PropTypes.func.isRequired,

    clearable: PropTypes.bool,

    readOnly: PropTypes.bool
  };

  onChange = (options) => {
    if (_.isNull(options)) {
      this.props.onChange(null);
    } else {
      this.props.onChange(options.map(option => option.value));
    }
  };

  render() {
    const options = getAllergenOptions();
    // we transform this.props.allergens into an array of objects with label and value to be able to use it as value for the select
    const selectedValues = this.props.allergens.map(allergen => {
      const option = options.find(option => option.value === allergen);
      if (option) {
        return option;
      } else {
        return {value: allergen, label: allergen};
      }
    });

    return (
      <div className="allergen_chooser">
        <LocalizableSelect
          name="action"
          value={selectedValues}
          options={options}
          onChange={this.onChange}
          clearable={this.props.clearable}
          readOnly={this.props.readOnly}
          multi
        />
      </div>
    );
  }

}

export default AllergenChooser;
